<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <div class="title-page-text">
                {{ $t('v2.select_delivery_address') }}
              </div>
              <v-spacer />
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-2 mb-6">
            <l-autocompleted
              v-model="place_id"
              :items="list_address"
              :open-menu="open_autocompleted"
              item-text="description"
              item-value="place_id"
              :placeholder="$t('v2.find_an_address')"
              outlined
              dense
              height="40"
              content-class="input--button mb-2"
              @set-value-menu="getValueMenu"
              @search-input="getValueAutocompleted"
            >
              <template v-slot:prepend-inner>
                <div class="d-flex">
                  <img src="@/assets/images/v2/img/icon_marker.png" alt="Marker" class="image-20">
                </div>
              </template>
            </l-autocompleted>
            <div class="flex-image px-2 py-4 cursor-pointer" @click="selectCurrentLocation">
              <div class="flex-image-avatar mr-4">
                <v-icon color="#272727" size="24">
                  mdi-crosshairs-gps
                </v-icon>
              </div>
              <div class="flex-image-content">
                <div class="flex-image-content-text font-14 ol-black font-weight-600">
                  {{ $t('v2.your_current_location') }}
                </div>
              </div>
            </div>
            <div class="div-line" />
            <div class="flex-image px-2 py-4 cursor-pointer" @click="goToMapsSelect">
              <div class="flex-image-avatar mr-4">
                <img src="@/assets/images/v2/img/icon_map_pin.png" alt="Pin maps">
              </div>
              <div class="flex-image-content">
                <div class="flex-image-content-text font-14 ol-black font-weight-600">
                  {{ $t('v2.select_from_map') }}
                </div>
              </div>
            </div>
            <div class="div-line" />
          </div>
          <div v-if="locations.history.length > 0">
            <div class="py-2 font-16 font-weight-600">
              {{ $t('v2.history') }}
            </div>
            <template v-for="(item, idx) in locations.history">
              <div :key="idx + '-item'" class="flex-image px-2 py-4 cursor-pointer" @click="selectHistory(item)">
                <div class="flex-image-avatar mr-4">
                  <v-icon color="#272727" size="24">
                    mdi-clock-time-three-outline
                  </v-icon>
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14 ol-black font-weight-600 one-line">
                    {{ item.name }}
                  </div>
                  <div class="flex-image-content-text font-12 ol-grey-content two-line">
                    {{ item.shipping_address }}
                  </div>
                </div>
              </div>
              <div :key="idx + '-line'" class="div-line" />
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import {
  autoComplete as autoCompleteMaps,
  placeDetail as placeDetailMaps,
  geoCodeByLatLng as geoCodeByLatLngMaps,
  distanceMatrix as distanceMatrixMaps
} from '@/api/maps'
import LAutocompleted from '@/components/v2/autocompleted.vue'
export default {
  components: {
    LAutocompleted
  },
  data() {
    return {
      place_id: null,
      search: null,
      list_address: [],
      open_autocompleted: false,
      params_google: {
        types: 'geocode|establishment',
        radius: 500,
        location: '',
        components: encodeURIComponent('country:ID')
      },
      data_location: {
        name: '',
        note: '',
        address: '',
        lat: 0,
        lng: 0
      },
      history: [],
      locations: {
        history: [],
        name: '',
        driver_note: '',
        shipping_address: '',
        shipping_lat: 0,
        shipping_lon: 0,
        shipping_radius: 0
      }
    }
  },
  watch: {
    'place_id': function(newItem) {
      if (typeof newItem !== 'undefined') {
        this.selectAddress(newItem)
      }
    },
    search: debounce(async function(val) {
      this.list_address = []
      if (val && val !== '') {
        const params = {
          address: val,
          params: Object.keys(this.params_google).map(key => key + '=' + this.params_google[key]).join('&')
        }
        this.getListAddress(params)
        this.open_autocompleted = true
      } else {
        this.list_address = []
        this.open_autocompleted = false
      }
    }, 2000)
  },
  mounted() {
    if (!('geolocation' in navigator)) {
      console.log('Geolocation is not available.')
    }
    navigator.geolocation.getCurrentPosition(pos => {
      this.params_google.location = encodeURIComponent(pos.coords.latitude + ', ' + pos.coords.longitude)
    }, () => {
      this.$store.state.block_location = true
    })
    const DETAIL_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
    if (DETAIL_LOCATION) {
      const detail_location = JSON.parse(DETAIL_LOCATION)
      this.locations = detail_location
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: '_checkout' }).catch(() => {})
    },
    goToMapsSelect() {
      this.$router.push({ name: '_maps_select' }).catch(() => {})
    },
    getValueAutocompleted(e) {
      this.search = e
    },
    getValueMenu(e) {
      this.open_autocompleted = e
    },
    async selectAddress() {
      if (this.place_id) {
        try {
          const { data } = await placeDetailMaps(this.place_id)
          this.$store.state.loading_axios = false
          this.setPlace(data.result)
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async getListAddress(params) {
      if (!this.$isEmpty(params)) {
        try {
          const { data } = await autoCompleteMaps(params)
          this.$store.state.loading_axios = false
          data.predictions.map(item => {
            this.list_address.push(item)
          })
        } catch (e) {
          this.list_address = []
        }
      }
    },
    async setPlace(place) {
      var select_store = this.$store.state.selected_store
      if (this.$store.state.selected_outlet) {
        select_store = this.$store.state.selected_outlet
      }
      const form = {
        origin_lat: Number(select_store.location_lat),
        origin_lon: Number(select_store.location_lon),
        destination: [
          {
            lat: place.geometry.location.lat,
            lon: place.geometry.location.lng
          }
        ]
      }
      const _this = this
      this.calcDistance(form).then(async(result) => {
        if (result.status === 'OK') {
          if (result.rows[0].elements[0].status === 'ZERO_RESULTS') {
            _this.$store.state.show_error = true
            _this.$store.state.error_message = this.$t('v2.check_your_location_again')
            _this.$store.state.error_type = 400
          // } else if (Math.ceil(result.rows[0].elements[0].distance.value / 1000) > select_store.delivery.max_radius_delivery) {
          //   _this.$store.state.show_error = true
          //   _this.$store.state.error_message = this.$t('v2.you_are_outside_the_store_delivery_limits')
          //   _this.$store.state.error_type = 400
          } else {
            _this.$set(_this.locations, 'name', place.name)
            _this.$set(_this.locations, 'driver_note', _this.data_location.note)
            _this.$set(_this.locations, 'shipping_address', place.formatted_address)
            _this.$set(_this.locations, 'shipping_lat', place.geometry.location.lat)
            _this.$set(_this.locations, 'shipping_lon', place.geometry.location.lng)
            _this.$set(_this.locations, 'shipping_radius', Math.ceil(result.rows[0].elements[0].distance.value / 1000))
            _this.$store.dispatch('saveLocationV2', _this.locations)
            _this.$router.push({ name: '_checkout' }).catch(() => {})
          }
        } else {
          _this.$store.state.show_error = true
          _this.$store.state.error_message = this.$t('v2.check_your_location_again')
          _this.$store.state.error_type = 400
        }
      })
    },
    selectHistory(item) {
      var select_store = this.$store.state.selected_store
      if (this.$store.state.selected_outlet) {
        select_store = this.$store.state.selected_outlet
      }
      const form = {
        origin_lat: Number(select_store.location_lat),
        origin_lon: Number(select_store.location_lon),
        destination: [
          {
            lat: item.shipping_lat,
            lon: item.shipping_lon
          }
        ]
      }
      const _this = this
      this.calcDistance(form).then(async(result) => {
        if (result.status === 'OK') {
          if (result.rows[0].elements[0].status === 'ZERO_RESULTS') {
            _this.$store.state.show_error = true
            _this.$store.state.error_message = this.$t('v2.check_your_location_again')
            _this.$store.state.error_type = 400
          // } else if (Math.ceil(result.rows[0].elements[0].distance.value / 1000) > select_store.delivery.max_radius_delivery) {
          //   _this.$store.state.show_error = true
          //   _this.$store.state.error_message = this.$t('v2.you_are_outside_the_store_delivery_limits')
          //   _this.$store.state.error_type = 400
          } else {
            _this.$set(_this.locations, 'name', item.name)
            _this.$set(_this.locations, 'driver_note', item.driver_note)
            _this.$set(_this.locations, 'shipping_address', item.shipping_address)
            _this.$set(_this.locations, 'shipping_lat', item.shipping_lat)
            _this.$set(_this.locations, 'shipping_lon', item.shipping_lon)
            _this.$set(_this.locations, 'shipping_radius', Math.ceil(result.rows[0].elements[0].distance.value / 1000))
            _this.$store.dispatch('saveLocationV2', _this.locations)
            _this.$router.push({ name: '_checkout' }).catch(() => {})
          }
        } else {
          _this.$store.state.show_error = true
          _this.$store.state.error_message = this.$t('v2.check_your_location_again')
          _this.$store.state.error_type = 400
        }
      })
    },
    async calcDistance(dataDistance) {
      try {
        const { data } = await distanceMatrixMaps(dataDistance)
        if (data.status === 'ZERO_RESULTS') {
          this.$store.state.show_error = true
          this.$store.state.error_message = this.$t('v2.check_your_location_again')
          this.$store.state.error_type = 400
        } else {
          return data
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    selectCurrentLocation() {
      var select_store = this.$store.state.selected_store
      if (this.$store.state.selected_outlet) {
        select_store = this.$store.state.selected_outlet
      }
      if (!('geolocation' in navigator)) {
        console.log('Geolocation is not available.')
      }
      navigator.geolocation.getCurrentPosition(async(pos) => {
        const form = {
          origin_lat: Number(select_store.location_lat),
          origin_lon: Number(select_store.location_lon),
          destination: [
            {
              lat: pos.coords.latitude,
              lon: pos.coords.longitude
            }
          ]
        }
        const _this = this
        this.calcDistance(form).then(async(result) => {
          if (result.status === 'OK') {
            if (result.rows[0].elements[0].status === 'ZERO_RESULTS') {
              _this.$store.state.show_error = true
              _this.$store.state.error_message = this.$t('v2.check_your_location_again')
              _this.$store.state.error_type = 400
            // } else if (Math.ceil(result.rows[0].elements[0].distance.value / 1000) > select_store.delivery.max_radius_delivery) {
            //   _this.$store.state.show_error = true
            //   _this.$store.state.error_message = this.$t('v2.you_are_outside_the_store_delivery_limits')
            //   _this.$store.state.error_type = 400
            } else {
              await _this.getAddress({
                lat: pos.coords.latitude,
                lon: pos.coords.longitude
              }).then(async(result) => {
                _this.$set(_this.locations, 'name', result.name)
                _this.$set(_this.locations, 'shipping_address', result.shipping_address)
              })
              _this.$set(_this.locations, 'driver_note', '')
              _this.$set(_this.locations, 'shipping_lat', pos.coords.latitude)
              _this.$set(_this.locations, 'shipping_lon', pos.coords.longitude)
              _this.$set(_this.locations, 'shipping_radius', Math.ceil(result.rows[0].elements[0].distance.value / 1000))
              _this.$store.dispatch('saveLocationV2', _this.locations)
              _this.$router.push({ name: '_checkout' }).catch(() => {})
            }
          } else {
            _this.$store.state.show_error = true
            _this.$store.state.error_message = this.$t('v2.check_your_location_again')
            _this.$store.state.error_type = 400
          }
        })
      })
    },
    async getAddress(point_map) {
      try {
        const { data } = await geoCodeByLatLngMaps(point_map)
        if (data.status === 'OK') {
          const i = data.results[0].address_components[0].types.findIndex((e) => {
            return e === 'plus_code'
          })
          const obj = {
            name: '',
            shipping_address: ''
          }
          if (i !== -1) {
            const arrAddress = data.results[0].formatted_address.split(', ')
            const x = arrAddress.findIndex((data_short) => {
              return data_short === data.results[0].address_components[0].short_name
            })
            arrAddress.splice(x, 1)
            const address = arrAddress.join(', ')
            const arrData = address.split(',')
            obj.name = arrData[0]
            arrData.shift()
            obj.shipping_address = arrData.join(', ')
          } else {
            const address = data.results[0].formatted_address
            const arrData = address.split(',')
            obj.name = arrData[0]
            arrData.shift()
            obj.shipping_address = arrData.join(', ')
          }
          return obj
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = this.$t('v2.check_your_location_again')
          this.$store.state.error_type = 400
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
